import Cookies from "js-cookie";
import updateUserLocation from "./updateUserLocation";

export default function setLocationCookie(id, title, url, lat, lng, phone) {
  // Set the cookie
  Cookies.remove("your_location");
  Cookies.set("your_location", id, { expires: 30 });

  updateUserLocation(id, title, url, lat, lng, phone);
}